// ReportsArchiveEntryCard — director entry into the M-6 report archive
// (searchable history of leader digests). Reactivation/archive aren't bottom-nav
// tabs, so the director reaches them from the dashboard. Self-contained nav.
import { useNavigate } from 'react-router-dom'

import { Icon, t } from '../design'

export function ReportsArchiveEntryCard() {
  const navigate = useNavigate()
  return (
    <button
      onClick={() => navigate('/reports')}
      className="card card-16"
      style={{
        width: '100%', textAlign: 'left', cursor: 'pointer', border: 'none',
        marginBottom: 12, display: 'flex', alignItems: 'center', gap: 12,
      }}
    >
      <span style={{
        width: 40, height: 40, borderRadius: 11, flexShrink: 0,
        background: 'var(--brand-100)', color: 'var(--brand-900)',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <Icon.Activity size={20} sw={2} />
      </span>
      <div className="flex-1" style={{ minWidth: 0 }}>
        <div className="t-body-s">{t('arch.title')}</div>
        <div className="t-caption">{t('arch.entryHint')}</div>
      </div>
      <Icon.ArrowRight size={18} sw={2} style={{ color: 'var(--text-3)' }} />
    </button>
  )
}
